import { createRootRoute, Outlet } from '@tanstack/react-router';
import { SiteFooter, SiteHeader } from '@cartcloser/ui/marketing';
import { FOOTER, NAV } from '../site.js';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader nav={NAV} cta={{ label: 'Contact', href: '/contact' }} />
      <div className="flex-1">
        <Outlet />
      </div>
      <SiteFooter columns={FOOTER} />
    </div>
  );
}
